import React, {useContext} from 'react';
import SwiperCore, {Navigation} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

import MySwiper from 'components/Shared/MySwiper';
import FilmScheduleCard from 'components/FilmScheduleCard';
import Context from 'utils/Context';

import './ScheduleCarousel.scss';

SwiperCore.use([Navigation]);

function ScheduleCarousel({onSeanceClick, seancesByDay, nbDays, titleHeader}) {
  const {goTo} = useContext(Context);

  const swiperProps = {
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      // when window width is >=
      450: {
        slidesPerView: 2,
      },
      // when window width is >=
      800: {
        slidesPerView: 3,
      },
      // when window width is >=
      1100: {
        slidesPerView: 5,
      },
    },
    pagination: {clickable: true},
    scrollbar: {draggable: true},
  };

  return (
    <div className="ScheduleCarousel">
      <MySwiper
        titleHeader={titleHeader}
        params={swiperProps}
        list={[...Array(nbDays).keys()].map(i => (
          <FilmScheduleCard seancesByDay={seancesByDay[i]} onSeanceClick={s => onSeanceClick(s)} goTo={goTo} />
        ))}
      />
    </div>
  );
}

export default ScheduleCarousel;
